module.exports = [{
      plugin: require('/Users/easonchiang/Projects/f2e-pomodoro/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/easonchiang/Projects/f2e-pomodoro/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/easonchiang/Projects/f2e-pomodoro/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
